export const rebuildUrlWithSearchParamsForDates = (
  url: string,
  startDate: string,
  endDate: string
) => {
  const [mainUrl, search] = url.split('?')
  const parsedSearch = new URLSearchParams(search)

  const newSearch = parsedSearch
  newSearch.set('startDate', startDate)
  newSearch.set('endDate', endDate)

  return [mainUrl, newSearch.toString()].join('?')
}
